module.exports = __webpack_public_path__ + "build/img/connexions_100.d8373f80.png";